import {
  setDisplayErrorSnackBar,
  setIsLoading,
} from "../../../../features/userSlice";
import { advertisingAccountsService } from "../../../../services/api/advertising-accounts.endpoints";
import store from "../../../../store";

async function getAdvertisingAccountsContent(
  oauthTokenHeader: string,
  setAdvertisingAccountContent: any,
  setErrorAccToPageStatus: any,
) {
  try {
    const response =
      await advertisingAccountsService.getAdvertisingAccounts(oauthTokenHeader);
    if (!response.status || response.status !== 200) {
      setErrorAccToPageStatus([response]);
      /* trackPromise(store.dispatch(setDisplayErrorSnackBar({ message: 'Something went wrong while Getting Page Content', type: 'error' }))); */
    } else {
      setAdvertisingAccountContent(response?.data?.data);
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      }),
    );
  }
}

async function advertisingAccountsToggle(
  oauthTokenHeader: string,
  setAdvertisingAccountToggleContent: any,
  data: any,
  account_shared_uid: any,
) {
  try {
    const response = await advertisingAccountsService.advertisingAccountsToggle(
      oauthTokenHeader,
      data,
      account_shared_uid,
    );
    if (!response.status || response.status !== 200) {
      // store.dispatch(setDisplayErrorSnackBar({ message: 'Something went wrong while toggling status', type: 'error' }));
    } else {
      store.dispatch(setIsLoading(true));
      setAdvertisingAccountToggleContent([response?.data?.data]);
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      }),
    );
  }
}

async function getTrafficSource(
  oauthTokenHeader: string,
  setTrafficSource: any,
) {
  try {
    const response =
      await advertisingAccountsService.getTrafficSource(oauthTokenHeader);
    if (!response.status || response.status !== 200) {
      store.dispatch(
        setDisplayErrorSnackBar({
          message: "Something went wrong while Getting Page Content",
          type: "error",
        }),
      );
    } else {
      setTrafficSource(response?.data?.data);
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      }),
    );
  }
}
async function getGeo(setAdAccountGeoDetails: any, oauthTokenHeader: string) {
  try {
    const response = await advertisingAccountsService.getGeo(oauthTokenHeader);
    if (!response.status || response.status !== 200) {
      store.dispatch(
        setDisplayErrorSnackBar({
          message: "Something went wrong while Getting Page Content",
          type: "error",
        }),
      );
    } else {
      setAdAccountGeoDetails(response?.data?.data);
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      }),
    );
  }
}
async function postGeo(oauthTokenHeader: string, data: any) {
  try {
    const response = await advertisingAccountsService.postGeo(
      oauthTokenHeader,
      data,
    );
    if (!response.status || response.status !== 200) {
      /* store.dispatch(setDisplayErrorSnackBar({ message: 'Something went wrong while Getting Page Content', type: 'error' })); */
    } else {
    }
  } catch (e: any) {
    /* store.dispatch(setDisplayErrorSnackBar({ message: e.parsedText.reason || 'Unknown error occurred', type: 'error' })); */
  }
}
async function postIndustry(oauthTokenHeader: string, data: any) {
  try {
    const response = await advertisingAccountsService.postIndustry(
      oauthTokenHeader,
      data,
    );
    if (!response.status || response.status !== 200) {
      /* store.dispatch(setDisplayErrorSnackBar({ message: 'Something went wrong while Getting Page Content', type: 'error' })); */
    } else {
    }
  } catch (e: any) {
    /* store.dispatch(setDisplayErrorSnackBar({ message: e.parsedText.reason || 'Unknown error occurred', type: 'error' })); */
  }
}
async function getIndustry(
  setAdAccountIndustryDetails: any,
  oauthTokenHeader: string,
) {
  try {
    const response =
      await advertisingAccountsService.getIndustries(oauthTokenHeader);
    if (!response.status || response.status !== 200) {
      store.dispatch(
        setDisplayErrorSnackBar({
          message: "Something went wrong while Getting Page Content",
          type: "error",
        }),
      );
    } else {
      setAdAccountIndustryDetails(response?.data?.data);
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      }),
    );
  }
}
async function getTerritory(
  setAdAccountTerritoryDetails: any,
  oauthTokenHeader: string,
) {
  try {
    const response =
      await advertisingAccountsService.getTerritories(oauthTokenHeader);
    if (!response.status || response.status !== 200) {
      store.dispatch(
        setDisplayErrorSnackBar({
          message: "Something went wrong while Getting Page Content",
          type: "error",
        }),
      );
    } else {
      setAdAccountTerritoryDetails(response?.data?.data);
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      }),
    );
  }
}

async function createAuctionInsight(
  oauthTokenHeader: any,
  data: any,
  setErrorText: any,
  setSuccess: any,
) {
  try {
    const response = await advertisingAccountsService.createAuctionInsight(
      oauthTokenHeader,
      data,
    );
    if (!response.status || response.status !== 200) {
      setErrorText("Something went wrong while creating auction insights.");
      store.dispatch(
        setDisplayErrorSnackBar({
          message: "Something went wrong while creating auction insights.",
          type: "error",
        }),
      );
      return response;
    } else {
      setSuccess(true);
      return response;
    }
  } catch (e: any) {
    setErrorText(e?.parsedText || "Unknown error occurred");
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      }),
    );
    return null;
  }
}

async function createAdAccount(
  oauthTokenHeader: string,
  data: any,
  setErrorTextWhileCreate: any,
  setCreateAccRes: any,
  setAdAccCreateResponseData: any,
  trackPromise: any,
) {
  try {
    const response = await advertisingAccountsService.createAdAccount(
      oauthTokenHeader,
      data,
    );
    if (response?.status !== 201) {
      setCreateAccRes(true);
      /* store.dispatch(setDisplayErrorSnackBar({ message: 'Something went wrong while Getting Page Content', type: 'error' })); */
    } else {
      setAdAccCreateResponseData([response?.data?.data]);
    }
  } catch (e: any) {
    if (e?.status !== undefined) {
      setErrorTextWhileCreate([e]);
      trackPromise(
        store.dispatch(
          setDisplayErrorSnackBar({
            message: e?.parsedText || "Unknown error occurred",
            type: "error",
          }),
        ),
      );
    } else
      trackPromise(
        store.dispatch(
          setDisplayErrorSnackBar({
            message: "Toggle Successfull",
            type: "success",
          }),
        ),
      );
  }
}
async function updateAdAccount(
  page_shared_uid: string,
  data: any,
  setAccountUpdateStatus: any,
  setAccountUpdateError: any,
  oauthTokenHeader: string,
  trackPromise: any /* , setSnackbarOpen:any  */,
) {
  try {
    const response = await advertisingAccountsService.updateAdAccount(
      page_shared_uid,
      oauthTokenHeader,
      data,
    );
    if (!response.status || response.status !== 200) {
      /*  setSnackbarOpen(false) */
      setAccountUpdateError(true);
      /* store.dispatch(setDisplayErrorSnackBar({ message: 'Something went wrong while Getting Page Content', type: 'error' })); */
    } else {
      setAccountUpdateStatus([response.data.data]);
      trackPromise(
        store.dispatch(
          setDisplayErrorSnackBar({
            message: "Updated Account Successfully",
            type: "success",
          }),
        ),
      );
    }
    return response;
  } catch (e: any) {
    if (e?.status !== undefined) {
      /*   setErrorTextWhileCreate([e]) */
      trackPromise(
        store.dispatch(
          setDisplayErrorSnackBar({
            message: e?.parsedText || "Unknown error occurred",
            type: "error",
          }),
        ),
      );
    } else
      trackPromise(
        store.dispatch(
          setDisplayErrorSnackBar({
            message: "Update Successfull",
            type: "success",
          }),
        ),
      );
  }
}

async function updateAssetLinks(
  oauthTokenHeader: string,
  data: any,
  page_shared_uid: any,
  trackPromise: any,
  setIsError: any,
) {
  try {
    const response = await advertisingAccountsService.updateAssetLinks(
      oauthTokenHeader,
      data,
      page_shared_uid,
    );
    if (!response.status || response.status !== 200) {
      /* store.dispatch(setDisplayErrorSnackBar({ message: 'Something went wrong while Getting Page Content', type: 'error' })); */
    } else {
      setIsError(true);
      trackPromise(
        store.dispatch(
          setDisplayErrorSnackBar({
            message: "Linked Aseets Updated Successfully",
            type: "success",
          }),
        ),
      );
    }
    return response;
  } catch (e: any) {
    setIsError(true);
  }
}

async function getAdAccountDetails(
  oauthTokenHeader: string,
  trafficSourceUid: string,
  adAccountId: string,
  setIsLoading: any,
  setAdAccountDetails: any,
  ad_companies_id?: string,
) {
  store.dispatch(setIsLoading(true));

  try {
    const response = await advertisingAccountsService.getAdAccountDetails(
      oauthTokenHeader,
      trafficSourceUid,
      adAccountId,
      ad_companies_id,
    );

    if (!response.status || response.status !== 200) {
      store.dispatch(
        setDisplayErrorSnackBar({
          message: "Something went wrong while Getting Page Content",
          type: "error",
        }),
      );
      return null;
    } else {
      setAdAccountDetails(response?.data);
      return response?.data;
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({ message: e?.parsedText, type: "error" }),
    );

    return null;
  } finally {
    store.dispatch(setIsLoading(false));
  }
}

async function getAdAccountDetailsOnClick(
  oauthTokenHeader: string,
  trafficSourceUid: string,
  adAccountId: string,
  setIsLoading: any,
  setAdAccountDetails: any,
  ad_companies_id?: string,
) {
  setIsLoading(true);
  try {
    const response = await advertisingAccountsService.getAdAccountDetails(
      oauthTokenHeader,
      trafficSourceUid,
      adAccountId,
      ad_companies_id,
    );

    if (!response.status || response.status !== 200) {
      store.dispatch(
        setDisplayErrorSnackBar({
          message: "Something went wrong while Getting Page Content",
          type: "error",
        }),
      );
    } else {
      setAdAccountDetails(response?.data);
      return response?.data;
    }
  } catch (e: any) {
    const errorMessage =
      typeof e === "string"
        ? e
        : e?.parsedText?.reason || "Unknown error occurred";

    store.dispatch(
      setDisplayErrorSnackBar({ message: errorMessage, type: "error" }),
    );

    return null;
  } finally {
    setIsLoading(false);
  }
}
async function postAdAccountDetails(
  oauthTokenHeader: string,
  data: any,
  account_uid: string,
) {
  try {
    const response = await advertisingAccountsService.postAdAccountDetails(
      oauthTokenHeader,
      data,
      account_uid,
    );

    if (!response.status || response.status !== 200) {
      store.dispatch(
        setDisplayErrorSnackBar({
          message: "Something went wrong while posting Ad Account Details",
          type: "error",
        }),
      );
    } else {
      // store.dispatch(
      //   setDisplayErrorSnackBar({
      //     message: "Ad Account Details Fetched Successfully",
      //     type: "success",
      //   })
      // );
    }
    return response;
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      }),
    );
  }
}

async function getSingleAdvertisingAccount(
  oauthTokenHeader: string,
  setSingleAdAccountData: any,
  setErrorAccToPageStatus: any,
  rowId: any,
  trackPromise: any,
) {
  try {
    const response =
      await advertisingAccountsService.getSingleAdvertisingAccount(
        rowId,
        oauthTokenHeader,
      );
    if (!response.status || response.status !== 200) {
      setErrorAccToPageStatus([response]);
      store.dispatch(
        setDisplayErrorSnackBar({
          message: "Something went wrong while updating Ad Account Details",
          type: "error",
        }),
      );
    } else {
      setSingleAdAccountData(response?.data?.data);
    }
  } catch (e: any) {
    trackPromise(
      store.dispatch(
        setDisplayErrorSnackBar({
          message: e?.parsedText || "Unknown error occurred",
          type: "error",
        }),
      ),
    );
  }
}

async function postWebToAcc(
  oauthTokenHeader: string,
  data: any,
  account_shared_uid: any,
) {
  try {
    const response = await advertisingAccountsService.postWebsiteToAccount(
      oauthTokenHeader,
      data,
      account_shared_uid,
    );
    if (!response.status || response.status !== 200) {
      store.dispatch(
        setDisplayErrorSnackBar({
          message: "Something went wrong while Getting Page Content",
          type: "error",
        }),
      );
    } else {
      store.dispatch(
        setDisplayErrorSnackBar({
          message: "Linked Assets Added Successfully",
          type: "success",
        }),
      );
    }
    return response;
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      }),
    );
  }
}

async function getCompanies(oauthTokenHeader: string, setCompanies: any) {
  try {
    const response =
      await advertisingAccountsService.getCompanies(oauthTokenHeader);
    if (!response.status || response.status !== 200) {
      store.dispatch(
        setDisplayErrorSnackBar({
          message: "Something went wrong while Getting the Companies",
          type: "error",
        }),
      );
    } else {
      setCompanies(response?.data?.data);
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      }),
    );
  }
}

export const advertisingAccountsEndPointLogic = {
  getAdvertisingAccountsContent,
  advertisingAccountsToggle,
  getTrafficSource,
  getAdAccountDetails,
  getSingleAdvertisingAccount,
  getGeo,
  getIndustry,
  createAdAccount,
  getTerritory,
  postGeo,
  postIndustry,
  updateAdAccount,
  updateAssetLinks,
  postWebToAcc,
  postAdAccountDetails,
  createAuctionInsight,
  getAdAccountDetailsOnClick,
  getCompanies,
};
